var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBolaConsejos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    style: {
      enableBackground: "new 0 0 35 35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#9B8C58;}\n\t.st1{fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bola-revision") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    className: "st0",
    cx: 17.5,
    cy: 17.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26,11.9c0.4-0.4,0.7-0.9,0.7-1.5v-1c0-1.1-0.9-1.9-1.9-1.9s-1.9,0.9-1.9,1.9v1c0,0.7,0.4,1.4,1,1.7 c-0.2,0.2-0.4,0.3-0.5,0.6c-0.4,0.7-0.7,1.5-0.8,2.3h-1.7c-0.5,0-1,0.4-1,1s0.4,1,1,1h1.6v1.9h0.6v8.7h3.9V13.6 C27.1,12.9,26.6,12.2,26,11.9z M23.5,10.4v-1c0-0.7,0.6-1.3,1.3-1.3s1.3,0.6,1.3,1.3v1c0,0.7-0.6,1.3-1.3,1.3S23.5,11.1,23.5,10.4 z M23.8,13.2v1.7h-0.6C23.4,14.3,23.6,13.8,23.8,13.2z M20.6,15.9c0-0.2,0.1-0.3,0.3-0.3h3.6v-2.9c0-0.1,0-0.1,0.1-0.2 c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0.2,0.2,0.3v3.2c0,0.2-0.1,0.3-0.3,0.3h-3.9C20.7,16.2,20.6,16.1,20.6,15.9z M24.8,16.9 c0.5,0,1-0.4,1-1v-3.2c0,0,0-0.1,0-0.1c0.4,0.2,0.7,0.6,0.7,1.1v4.5h-3.2v-1.3H24.8z M23.8,18.8h0.6v8.1h-0.6V18.8z M25.1,26.9 v-8.1h1.3v8.1H25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16,13.9h0.6v0.6H16V13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.3,13.9H18v0.6h-0.6V13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.7,16.8l1.4-0.9h1.2v-3.2h-4.5v3.2h1.9V16.8z M15.4,15.2v-1.9h3.2v1.9h-0.7l-0.5,0.4v-0.4H15.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.3,19.1c0-0.1,0.1-0.2,0.1-0.3c0-0.5-0.4-1-1-1h-2.9v-1.6c0-0.2-0.1-0.5-0.2-0.6c0.5-0.3,0.9-0.9,0.9-1.6 v-1c0-1.1-0.9-1.9-1.9-1.9s-1.9,0.9-1.9,1.9v1c0,0.7,0.3,1.2,0.8,1.6c-0.1,0.3-0.2,0.7-0.3,1H8.9c-0.5,0-1,0.4-1,1s0.4,1,1,1h0.3 v2.9c0,0.6,0.4,1.2,0.9,1.4L9,26.4c0,0.1,0,0.2,0,0.3c0,0.5,0.4,0.9,0.9,0.9c0.4,0,0.7-0.2,0.8-0.6l0.4-1.1l0.9-2.5l0.1-0.3h2.4 v0.3v0.3v0.6V25v0.6v0.7v1.2h6.8v-6.5h0.6v-1.9H17.3z M16.4,18.5c0.2,0,0.3,0.1,0.3,0.3c0,0.2-0.1,0.3-0.3,0.3h-3.9 c-0.2,0-0.3-0.1-0.3-0.3v-2.6c0-0.2,0.1-0.3,0.3-0.3s0.3,0.1,0.3,0.3v2.3H16.4z M10.9,13.9v-1c0-0.7,0.6-1.3,1.3-1.3 c0.7,0,1.3,0.6,1.3,1.3v1c0,0.7-0.6,1.3-1.3,1.3C11.4,15.2,10.9,14.7,10.9,13.9z M10,26.7c0,0.1-0.1,0.2-0.2,0.2 c-0.1,0-0.2-0.1-0.2-0.2c0,0,0-0.1,0-0.1l1.2-3.6c0,0,0.1,0,0.1,0h0.5L10,26.7z M14.4,22.4h-3.6c-0.5,0-1-0.4-1-1v-3.6h-1 c-0.2,0-0.3-0.1-0.3-0.3s0.1-0.3,0.3-0.3h1.7c0,0.3-0.1,0.5-0.1,0.8v3.1c0,0.4,0.3,0.6,0.6,0.6h3.2V22.4z M14.4,21.1h-3.2V18 c0-0.7,0.1-1.3,0.3-2c0,0.1,0,0.1,0,0.2v2.6c0,0.5,0.4,1,1,1h1.9V21.1z M20.6,26.9h-5.5v-5.8h5.5V26.9z M21.2,20.4h-6.2v-0.6h6.2 V20.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolaConsejos);
export default __webpack_public_path__ + "static/media/bola-consejos.48bf447601301327f0c1cc16fa05f9ea.svg";
export { ForwardRef as ReactComponent };